import React, { useState } from 'react';
import SearchBar from '../common/Searchbar';
import ChapterList from './ChapterList';
import closeIcon from '../../assets/images/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setTOCOpen } from '../../features/TOC/TOCOpenSlice';
import { TocElement } from '../../types/TocElement';

interface TOCModalProps {
    chapters: TocElement[];
    offset: number;
}

const TOCModal: React.FC<TOCModalProps> = ({ chapters, offset }) => {
    const [searchTerm, setSearchTerm] = useState<string>('');
    const dispatch = useDispatch();
    const isopenToc = useSelector(
        (state: { TOCOpen: { isOpen: boolean } }) => state.TOCOpen.isOpen
    );

    const TOCclickHandler = () => {
        dispatch(setTOCOpen(!isopenToc));
    };

    // Filter chapters based on the search term
    const filteredChapters = chapters.filter((chapter) =>
        chapter.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="modal-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center w-full h-full z-50 ">
            <div className="modal bg-white pb-6 pt-4 px-12 rounded-xl shadow-lg flex flex-col font-sans lg:w-[60rem] h-[40rem] ">
                <div className="flex justify-between ">
                    <div className="flex items-center ">
                        <h1 className="text-2xl text-black text-nowrap ">
                            Table of Content
                        </h1>
                        <SearchBar
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                    </div>
                    <div>
                        <button
                            className="mt-2"
                            onClick={TOCclickHandler}
                            data-testid="toc-modal-close-button"
                        >
                            <img src={closeIcon} alt="close icon" />
                        </button>
                    </div>
                </div>
                <hr className="border-solid border-gray-300 mt-4 -mx-12" />
                <div className="overflow-y-scroll custom-scrollbar">
                    <ChapterList chapters={filteredChapters} offset={offset} />
                </div>
            </div>
        </div>
    );
};

export default TOCModal;
